
























import Vue from "vue";
import { mapState, mapMutations } from "vuex";
import { RootState } from "@/store";
import * as m from "@/store/modules/AlertModule/mutations";

export default Vue.extend({
    computed: {
        ...mapState({
            alertList: (state: RootState) => state.alert.list,
        }),
    },
    methods: {
        ...mapMutations([m.REMOVE_ALERT_AT]),
        dismissErrorAt(idx): void {
            this[m.REMOVE_ALERT_AT](idx);
        },
    },
});
